export default [
  {
    path: "/relatorios/produtor/vendas",
    name: "reports-revenue-producer",
    component: () => import("../views/reports/ProducerRevenue.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true
    }
  },
  {
    path: "/relatorios/coprodutor/vendas",
    name: "reports-comission-coproducer",
    component: () => import("../views/reports/CoProducerComission.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true
    }
  },
  {
    path: "/relatorios/clientes",
    name: "reports-clients",
    component: () => import("../views/reports/Clients.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["clientes"],
      viewContainer: true
    }
  }
];
